import { render, staticRenderFns } from "./FishDialog.vue?vue&type=template&id=f008e9d2&scoped=true&"
import script from "./FishDialog.vue?vue&type=script&lang=js&"
export * from "./FishDialog.vue?vue&type=script&lang=js&"
import style0 from "./FishDialog.vue?vue&type=style&index=0&id=f008e9d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f008e9d2",
  null
  
)

export default component.exports